import React, { useState } from "react";
import SectionHead from "./SectionHead";
import { ImQuotesLeft } from 'react-icons/im';
import Card from "../UI/Card";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';
import { testimonials } from "../data";

const Testimonials = () => {
    const [index, setIndex] = useState(0);
    const { name, quote, job, avatar } = testimonials[index];

    const prevTestimonialHandler = () => {
        setIndex(prevIndex => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
    };

    const nextTestimonialHandler = () => {
        setIndex(prevIndex => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <section className="testimonials">
            <div className="testimonials__container">
                <SectionHead icon={<ImQuotesLeft />} title="Testimonials" className="testimonials__head" />
                <Card className="testimonial">
                    <div className="testimonial__avatar">
                        <img src={avatar} alt={name} />
                    </div>
                    <div>
                        <p className="testimonial__quote">{`"${quote}"`}</p>
                        <h5>{name}</h5>
                        <small className="testimonial__title">{job}</small>
                    </div>
                </Card>
            </div>

            <div className="testimonials__btn-container">
                <button className="testimonials__btn" onClick={prevTestimonialHandler}><IoIosArrowDropleftCircle /></button>
                <button className="testimonials__btn" onClick={nextTestimonialHandler}><IoIosArrowDroprightCircle /></button>
            </div>
        </section>
    );
}

export default Testimonials;
